// Colocated strings for DuckDbDataTable (SKILL.md rule 11, PACKAGING_PLAN §3.2).
// Consumed by ../setup.js as `useComponentI18n(messages)` from `@rdrive/i18n`, i.e. a LOCAL
// composer with the warn flags off: these three keys resolve here, while a header's `titleKey` is
// an APP key that resolves through the root composer by design (the base charts' rule, PLATFORM.md
// §6 decision 17).
//
// `search` (the search field's label), `noData` and `itemsPerPage` (the mobile table's texts) are
// lifted from what issue-analysis's grid resolved through its root composer before
// IA_ABSORPTION_PLAN Phase 4 step 13.3a — its `src/locales.js` over `@rdrive/vocabulary`, the
// same values in all 10 locales as `@rdrive/plugin-items-grid`'s ItemsGrid copies.
import de from './de.json';
import en from './en.json';
import fr from './fr.json';
import it from './it.json';
import nl from './nl.json';
import pl from './pl.json';
import ptBR from './pt-BR.json';
import th from './th.json';
import vi from './vi.json';
import zhHans from './zh-Hans.json';
import zhHant from './zh-Hant.json';

export default {
  de,
  en,
  fr,
  it,
  nl,
  pl,
  'pt-BR': ptBR,
  th,
  vi,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
};
